import { Titulo } from "./Titulo";

export default Titulo